import { ApiUrl } from "../utils/modules";

class CategorieServices {
  constructor(api) {
    this.api = api;
  }

  create(data) {
    return this.api.post(ApiUrl + "categorie", data);
  }

  getAll() {
    return this.api.get(ApiUrl + "categorie?sort=rang");
  }

  getAllGrouped() {
    return this.api.get(ApiUrl + "categorie/groupes");
  }

  getOne(id) {
    return this.api.get(ApiUrl + `categorie/${id}`);
  }

  update(id, data) {
    return this.api.put(ApiUrl + `categorie/${id}`, data);
  }

  delete(id) {
    return this.api.delete(ApiUrl + `categorie/${id}`);
  }

  patchManyByGroupe(idCategorieGroupe, updates) {
    return this.api.patch(ApiUrl + "categorie/update-many-by-groupe", {
      idCategorieGroupe,
      updates,
    });
  }
}

export default CategorieServices;
